var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "37.008%",
    x2: "6.577%",
    y2: "76.494%",
    id: "check_svg__a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1BC092",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EB0BE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "url(#check_svg__a)",
    cx: 11.859,
    cy: 11.859,
    r: 11.859
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M3.388 11.991l6.018 5.598L20.13 6.776"
  }))));
};

export default SvgCheck;